import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Box, Center, FlatList } from "native-base";
import { useTranslation } from "@madmedical/i18n";
import useResponsive from "../../util/useResponsive";
import ListHeader from "../../molecules/ListHeader";
import Paper from "../../atoms/Paper";
import EvaluationListItem from "../../molecules/ListItem/EvaluationListItem";
import Headline from "../../molecules/Headline";
import HealthEvaluationTable from "../../organisms/HealthEvaluationTable";
import { useEvaluations } from "../../providers/evaluation";
import ButtonLink from "../../atoms/ButtonLink";
import { useCurrentPatient } from "../../providers/currentPatient";
const Evaluations = () => {
    var _a;
    const { isSmallScreen } = useResponsive();
    const { evaluations } = useEvaluations();
    const { t } = useTranslation();
    const { patient } = useCurrentPatient();
    const packages = ((_a = patient === null || patient === void 0 ? void 0 : patient.packages) !== null && _a !== void 0 ? _a : []);
    if (patient && packages.some((item) => (item === null || item === void 0 ? void 0 : item.type) === "basic")) {
        return null;
    }
    if (!evaluations.length)
        return null;
    return isSmallScreen ? (_jsxs(_Fragment, { children: [_jsx(ListHeader, { title: t("latestResults"), borderBottomWidth: 0, px: 0 }), _jsxs(Paper, Object.assign({ mb: 3 }, { children: [_jsx(FlatList, { minWidth: "full", showsVerticalScrollIndicator: false, data: evaluations, renderItem: ({ item }) => (_jsx(EvaluationListItem, { evaluation: item })), keyExtractor: ({ id }) => id, overflow: "hidden" }), _jsx(Center, Object.assign({ my: 4, width: "full" }, { children: _jsx(ButtonLink, Object.assign({ size: "sm", variant: "outlined", route: "opinions", params: {} }, { children: t("viewAll") })) }))] }))] })) : (_jsxs(Paper, Object.assign({ mb: 3 }, { children: [_jsx(Headline, { title: t("latestResults"), size: "xs", py: 6 }), _jsxs(Box, Object.assign({ px: 6, py: 4, width: "full" }, { children: [_jsx(HealthEvaluationTable, {}), _jsx(Center, Object.assign({ mt: 4 }, { children: _jsx(ButtonLink, Object.assign({ size: "sm", variant: "outlined", route: "opinions", params: {} }, { children: t("viewAll") })) }))] }))] })));
};
export default Evaluations;
